module.exports = __webpack_public_path__ + "static/installsnippet-7b8f7fa3d3936aab2ee6e64460c7a828.mp4";